import { DataGrid } from '@mui/x-data-grid';
import Utils from '../../components/Utils';
import { DataSetValue } from '../../types/DataSetValue';

export default function MAIDDataGrid(props: { rows: DataSetValue[] }) {
    return (
        <DataGrid
            columns={[
                {
                    width: 320,
                    field: 'maid',
                    headerName: 'MAID',
                },
                {
                    width: 120,
                    field: 'saleDate',
                    headerName: 'Date of Visit',
                    valueGetter: (value: Date) => {
                        return Utils.formatDate(value);
                    },
                },
                {
                    width: 120,
                    field: 'deviceType',
                    headerName: 'Device Type',
                },
                {
                    width: 180,
                    field: 'segmentId',
                    headerName: 'Segment ID',
                },
            ]}
            rows={props.rows}
            hideFooter
        />
    );
}
